import Swal from 'sweetalert2';
import { questionSubscriptionTarget } from '../../questionBank/paidQuestionFlow';
import { unlockPodcastWithCoins } from '../../services/podcastDetailService';
import { buildQuestionBankFlowState } from '../../questionBank/qbankFlowState';

export function podcastRouteFlow(route = {}, fallback = {}) {
  route = route || {};
  fallback = fallback || {};
  const cached = Number(fallback.category_id) === 12 ? fallback : {};
  const explicitEntry = route.podcastId != null || route.podcast_id != null || route.audio_podcast_id != null;
  const input = { ...(explicitEntry ? {} : cached), ...route, category_id: 12 };
  const stateId = route.stateId ?? route.states_id ?? route.state_id;
  const subjectId = route.subjectId ?? route.subject_id;
  const podcastId = route.podcastId ?? route.podcast_id ?? route.audio_podcast_id;
  if (stateId != null) { input.state_id = Number(stateId); input.selectedState = { ...input.selectedState, state_id: Number(stateId) }; }
  if (subjectId != null) { input.subject_id = Number(subjectId); input.selectedSubject = { ...input.selectedSubject, id: Number(subjectId) }; }
  if (podcastId != null) { input.podcast_id = Number(podcastId); input.selectedPodcast = { ...input.selectedPodcast, id: Number(podcastId) }; }
  if (route.topicId != null) input.topic_id = Number(route.topicId);
  return buildQuestionBankFlowState(input);
}

export function podcastNeedsPurchase(item = {}) {
  const raw = item.raw || item;
  return String(item.freePaid ?? raw.free_paid ?? 'P').toUpperCase() === 'P' &&
    Number(item.paymentStatus ?? raw.payment_status ?? 0) !== 1;
}

export function podcastSubscriptionTarget(item = {}, context = {}) {
  return questionSubscriptionTarget({ ...item, raw: { ...(item.raw || item), categoryId: 12, category_id: 12 } }, {
    ...context, categoryId: 12,
    stateId: context.stateId || context.states_id || context.state_id || context.selectedState?.state_id,
    subjectId: context.subjectId || context.subject_id || context.selectedSubject?.id,
    examId: context.examId || context.exam_id || context.exams_id || 0,
  });
}

export function podcastDetailFlow(item, context = {}) {
  const target = podcastSubscriptionTarget(item, context).state;
  return { ...context, ...target, category_id: 12, categoryId: 12,
    state_id: target.stateId, states_id: target.stateId,
    subject_id: Number(item.raw?.subject_id || context.subject_id || context.selectedSubject?.id || 0),
    selectedPodcast: item, podcastId: Number(item.id ?? item.audio_podcast_id), podcast_id: Number(item.id ?? item.audio_podcast_id),
  };
}

export async function promptPodcastPurchase(item, context, navigate, onUnlocked, coinsOnly = false) {
  try {
    const choice = coinsOnly ? { isDenied: true } : await Swal.fire({ icon: 'info', title: 'Locked Podcast',
      text: item.subscriptionMessage || item.raw?.subscription_message || 'Subscribe or unlock this podcast with coins.',
      showCancelButton: true, confirmButtonText: 'Subscribe', showDenyButton: true,
      denyButtonText: 'Unlock with Coins', cancelButtonText: 'Cancel' });
    if (choice.isConfirmed) {
      const target = podcastSubscriptionTarget(item, context);
      navigate(target.pathname, { state: { ...target.state, subscriptionBackTarget: context.subscriptionBackTarget } });
    } else if (choice.isDenied) {
      await unlockPodcastWithCoins({ audio_podcast_id: Number(item.id ?? item.audio_podcast_id) });
      await onUnlocked();
    }
  } catch (error) {
    await Swal.fire({ icon: 'error', title: 'Unable to unlock podcast', text: error.message || 'Unable to verify podcast access.' });
  }
}
